import { render, staticRenderFns } from "./MyTopics.vue?vue&type=template&id=09bff47b&"
import script from "./MyTopics.vue?vue&type=script&lang=js&"
export * from "./MyTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports